import { createAction, props } from '@ngrx/store';
import { FinancialDetailsState } from '@store/reducers/income-net-worth/income-net-worth.reducer';

export const UpdateIncomeNetWorth = createAction(
  '[Income Net Worth] Update',
  props<{ payload: FinancialDetailsState }>(),
);

export const UpdateIncomeNetWorthValidationStatus = createAction(
  '[Income Net Worth] Update Validation Status',
  props<{ payload: 'VALID' | 'INVALID' }>(),
);
